function renderDate(date) {
  let options = {day: "2-digit", month: "2-digit", year: "numeric"}
  // return new Intl.DateTimeFormat('de-DE', options).format(new Date(date));
  if (date) {
    return new Date(date).toLocaleDateString(undefined, options);
  } else {
    return "";
  }
}

function renderLicenceType(licenceType) {
  switch (licenceType) {
    case 'LICENCE_AC':
      return '<span class="mf-box-green">AC Licence</span>';
    case 'LICENCE_SC':
      return '<span class="mf-box-red">SC Licence</span>';
    case 'INFO_AC':
      return 'Info';
    case 'BLOCKING_TBA_AC':
      return '<span class="mf-box-yellow">TBA Blocking</span>';
    case 'BLOCKING_YES_AC':
      return '<span class="mf-box-red">Blocking</span>';
    case 'BLOCKING_YES_SC':
      return '<span class="mf-box-red">Blocking</span>';
    default:
      return licenceType;
  }
}

function renderOfferState(offerState) {
  switch (offerState) {
    case 'CREATED':
      return '<span class="mf-box-yellow">Created</span>';
    case 'SUBMITTED':
      return '<span class="mf-box-green">Ordered</span>';
    case 'CANCELLED':
      return '<span class="mf-box-red">Cancelled</span>';
    default:
      return offerState;

  }
}

function renderExclusive(isExclusive) {
  if (isExclusive) {
    return "Exclusive";
  } else {
    return "Not Exclusive";
  }
}

function renderContactType(type) {
  switch (type) {
    case 'AC':
      return '<span class="mf-box-green">Acquisition</span>';
    case 'SC':
      return '<span class="mf-box-red">Sales</span>';
    default:
      return type;
  }
}

export {renderDate, renderLicenceType, renderExclusive, renderContactType, renderOfferState};
